(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-category"]) return;
  try {
    
  if (!customElements.get('bw-collection')) {
    customElements.define('bw-collection', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.bw-browse__grid');
        this.cards = Array.from(this.grid.children);
        this.onChange = () => this.refresh();
        this.addEventListener('change', this.onChange);
        this.refresh();
      }
      disconnectedCallback() { this.removeEventListener('change', this.onChange); }
      refresh() {
        const mode = this.querySelector('[data-sort]').value;
        const inStock = this.querySelector('[data-availability]').checked;
        const cards = [...this.cards].sort((a, b) => {
          if (mode === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
          if (mode === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
          if (mode === 'title') return a.dataset.name.localeCompare(b.dataset.name);
          return Number(a.dataset.order) - Number(b.dataset.order);
        });
        let count = 0;
        for (const card of cards) {
          card.hidden = inStock && card.dataset.available !== 'true';
          if (!card.hidden) count += 1;
          this.grid.append(card);
        }
        this.querySelector('[data-empty]').hidden = count !== 0;
        const status = this.querySelector('[data-results]');
        status.textContent = status.dataset.countTemplate.replace('__COUNT__', String(count));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-email-capture"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bw-email-capture')) {
    customElements.define('bw-email-capture', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.form = this.querySelector('form');
        this.querySelector('[data-close]').addEventListener('click', () => this.dismiss(), options);
        this.querySelector('[data-expand]').addEventListener('click', () => this.expand(), options);
        this.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); this.dismiss(); } }, options);
        this.form?.addEventListener('submit', () => {
          this.write('sessionStorage', 'bw-email-pending', '1');
          const target = new URL(location.href);
          target.searchParams.set('bw_email', '1');
          target.hash = this.form.id;
          const redirect = this.form.querySelector('[name="return_to"]');
          if (redirect) redirect.value = target.pathname + target.search + target.hash;
        }, options);
        const result = this.querySelector('[data-result]');
        const returned = new URL(location.href).searchParams.get('bw_email') === '1' || location.hash === '#' + this.form?.id || this.read('sessionStorage', 'bw-email-pending') === '1';
        if (result && returned) {
          this.write('sessionStorage', 'bw-email-pending', '');
          if (result.dataset.result === 'success') this.write('localStorage', 'bw-email-subscribed-until', String(Date.now() + 365 * 86400000));
          this.show(true);
          result.focus();
          return;
        }
        if (this.dataset.designMode === 'true' || this.dataset.subscribed === 'true') return;
        if (this.read('sessionStorage', 'bw-email-seen') === '1') return;
        if (Number(this.read('localStorage', 'bw-email-snooze-until')) > Date.now()) return;
        if (Number(this.read('localStorage', 'bw-email-subscribed-until')) > Date.now()) return;
        this.timer = setTimeout(() => this.tryShow(), Number(this.dataset.delay || 6) * 1000);
      }
      read(storage, key) { try { return window[storage].getItem(key); } catch { return null; } }
      write(storage, key, value) { try { window[storage].setItem(key, value); } catch {} }
      tryShow() {
        if (document.hidden || document.querySelector('dialog[open], cart-drawer.active, details.menu-opening')) return;
        if (Array.from(document.querySelectorAll('#shopify-pc__banner, [role="dialog"][aria-modal="true"]')).some(element => element.getClientRects().length)) return;
        if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return;
        this.show(false);
      }
      show(expanded) {
        this.previousFocus = document.activeElement;
        const compact = !expanded && window.matchMedia('(max-width: 749px)').matches;
        this.toggleAttribute('data-compact', compact);
        this.querySelector('[data-teaser]').hidden = !compact;
        this.querySelector('[data-content]').hidden = compact;
        this.hidden = false;
        this.write('sessionStorage', 'bw-email-seen', '1');
        const announcement = this.querySelector('[data-announcement]');
        if (!expanded) announcement.textContent = announcement.dataset.message;
      }
      expand() {
        this.removeAttribute('data-compact');
        this.querySelector('[data-teaser]').hidden = true;
        this.querySelector('[data-content]').hidden = false;
        this.querySelector('[data-expand]').setAttribute('aria-expanded', 'true');
        this.querySelector('input[type=email]')?.focus();
      }
      dismiss() {
        const hadFocus = this.contains(document.activeElement);
        this.hidden = true;
        this.write('localStorage', 'bw-email-snooze-until', String(Date.now() + Number(this.dataset.days || 30) * 86400000));
        if (hadFocus && this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.abort = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bw-carousel')) {
    customElements.define('bw-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.buttons = Array.from(this.querySelectorAll('[data-go]'));
        if (!this.track || !this.slides.length) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.index = 0;
        this.querySelector('[data-controls]').hidden = this.slides.length < 2;
        this.setAttribute('data-ready', '');
        this.querySelector('[data-previous]').addEventListener('click', () => this.go(this.index - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1), options);
        this.buttons.forEach((button, index) => button.addEventListener('click', () => this.go(index), options));
        this.querySelector('[data-controls]').addEventListener('keydown', event => {
          const moves = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
          if (!(event.key in moves)) return;
          event.preventDefault();
          const target = (moves[event.key] + this.slides.length) % this.slides.length;
          this.go(target);
          this.buttons[target].focus({ preventScroll: true });
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            const width = this.track.clientWidth;
            if (width) this.update(Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width))), true);
          });
        }, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index, false);
        }, options);
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(() => this.go(this.index, false));
          this.resize.observe(this.track);
        }
        this.track.addEventListener('pointerdown', () => {
          this.activate(this.index - 1);
          this.activate(this.index + 1);
        }, { ...options, passive: true });
        this.update(0, false);
        const firstImage = this.slides[0].querySelector('img');
        const ready = firstImage ? firstImage.decode().catch(() => {}) : Promise.resolve();
        ready.then(() => {
          if (!this.isConnected) return;
          this.prefetchFrame = requestAnimationFrame(() => {
            this.prefetchFrame = requestAnimationFrame(() => {
              if (this.isConnected) this.activate(this.index + 1);
            });
          });
        });
      }
      activate(index) {
        const target = (index + this.slides.length) % this.slides.length;
        this.slides[target].querySelectorAll('template[data-carousel-image]').forEach(template => {
          const content = template.content.cloneNode(true);
          content.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
          template.replaceWith(content);
        });
      }
      go(index, animate = true) {
        const next = (index + this.slides.length) % this.slides.length;
        this.activate(next);
        this.update(next, true);
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: next * this.track.clientWidth, behavior: animate && !reduced ? 'smooth' : 'auto' });
      }
      update(index, announce) {
        const changed = this.index !== index;
        this.index = index;
        this.activate(index);
        if (changed) this.activate(index + 1);
        this.querySelector('[data-active-label]').textContent = this.slides[index].getAttribute('aria-label') + ' · ' + (index + 1) + ' / ' + this.slides.length;
        this.slides.forEach((slide, i) => {
          slide.inert = i !== index;
          if (i === index) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.buttons.forEach((button, i) => {
          if (i === index) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        if (announce && changed) this.querySelector('[data-status]').textContent = this.slides[index].getAttribute('aria-label');
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.resize?.disconnect();
        cancelAnimationFrame(this.prefetchFrame);
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bw-newsletter-popup')) {
    customElements.define('bw-newsletter-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.panel = this.querySelector('aside');
        this.storageKey = 'bw-newsletter-dismissed-until';
        const options = { signal: this.abort.signal };
        const dismiss = () => {
          this.panel.hidden = true;
          clearTimeout(this.timer);
          this.remember(Date.now() + 7 * 24 * 60 * 60 * 1000);
        };
        this.querySelector('[data-dismiss]').addEventListener('click', dismiss, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); dismiss(); }
        }, options);
        this.addEventListener('shopify:section:select', () => { this.panel.hidden = false; }, options);
        if (this.querySelector('[data-success]')) {
          this.remember(Date.now() + 365 * 24 * 60 * 60 * 1000);
          this.panel.hidden = false;
          return;
        }
        if (this.querySelector('[data-error]')) { this.panel.hidden = false; return; }
        try { if (Number(localStorage.getItem(this.storageKey)) > Date.now()) return; } catch {}
        const reveal = () => {
          const playing = Array.from(document.querySelectorAll('video')).some(video => !video.paused && !video.ended);
          const typing = document.activeElement?.matches('input,textarea,select,[contenteditable=true]');
          const busy = document.querySelector('dialog[open], .drawer.active, .menu-drawer-container[open]');
          if (document.hidden || playing || typing || busy) { this.timer = setTimeout(reveal, 2000); return; }
          this.panel.hidden = false;
        };
        const delay = Number(this.dataset.delay) || 12000;
        this.timer = setTimeout(reveal, matchMedia('(max-width:749px)').matches ? Math.max(delay, 20000) : delay);
      }
      remember(until) {
        if (this.dataset.editor === 'true') return;
        try { localStorage.setItem(this.storageKey, String(Math.max(until, Number(localStorage.getItem(this.storageKey)) || 0))); } catch {}
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.abort = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-review-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bw-review-edit')) {
    customElements.define('bw-review-edit', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bw-review-edit__track');
        this.controls = this.querySelector('.bw-review-edit__controls');
        this.cards = Array.from(this.querySelectorAll('[data-variant-id]'));
        this.onScroll = () => this.updateControls();
        this.onClick = (event) => {
          const button = event.target.closest('[data-direction]');
          if (!button) return;
          const direction = Number(button.dataset.direction);
          const step = this.track.clientWidth + parseFloat(getComputedStyle(this.track).columnGap || '0');
          const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          this.track.scrollTo({ left: Math.max(0, Math.min(max, this.track.scrollLeft + direction * step)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.controls.addEventListener('click', this.onClick);
        this.observer = new ResizeObserver(() => this.updateControls());
        this.observer.observe(this.track);
        if (this.dataset.productMode === 'true' && typeof subscribe === 'function') {
          const ids = JSON.parse(this.dataset.variantIds || '[]').map(String);
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const id = String(event.data?.variant?.id || '');
            if (!ids.includes(id)) return;
            this.cards.forEach((card) => { card.hidden = card.dataset.variantId !== id; });
            this.hidden = !this.cards.some((card) => !card.hidden);
            this.track.scrollLeft = 0;
            requestAnimationFrame(() => this.updateControls());
          });
        }
        this.updateControls();
      }
      updateControls() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.controls.hidden = max <= 2;
        this.controls.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft <= 2;
        this.controls.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft >= max - 2;
      }
      disconnectedCallback() {
        this.unsubscribe?.();
        this.observer?.disconnect();
        this.track?.removeEventListener('scroll', this.onScroll);
        this.controls?.removeEventListener('click', this.onClick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
